import styles from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <span className={styles.left}>© 2026 FINDMORE SOLUTIONS</span>
        <span className={styles.right}>
          Aplicação para gestão e avaliação de desempenho 360º
        </span>
      </div>
    </footer>
  );
}
